import React from 'react';
import { withRouter } from 'react-router-dom';

import { Helpers } from '../../core/src/helpers';
import IntelContainer from '../../main/components/badge-container';
import { withError } from '../../shared/components/error-boundary';

import '../css/pdp-intel-badge-container.less';

const pdpIntelBadgeMap = {
    '9gi3': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i3-9th-gen-logo1572637172891674.png',
        message: ['9th Generation Intel® Core™ i3 processor'],
    },
    '9gi5': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i5-9th-gen-logo1572637209952686.png',
        message: ['9th Generation Intel® Core™ i5 processor'],
    },
    '9gi7': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i7-9th-gen-logo1572637232097676.png',
        message: ['9th Generation Intel® Core™ i7 processor'],
    },
    '9gi9': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i9-9th-gen-logo1572637266897154.png',
        message: ['9th Generation Intel® Core™ i9 processor'],
    },
    '10gi3': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i3-10th-gen-logo1572637192978687.png',
        message: ['10th Generation Intel® Core™ i3 processor'],
    },
    '10gi5': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i5-10th-gen-logo1572637221658788.png',
        message: ['10th Generation Intel® Core™ i5 processor'],
    },
    '10gi7': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i7-10th-gen-logo1572637255052340.png',
        message: ['10th Generation Intel® Core™ i7 processor'],
    },
    '10gi9': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i9-10th-gen-logo1572637277010195.png',
        message: ['10th Generation Intel® Core™ i9 processor'],
    },
    '8gi3': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i3-8th-gen-logo1572888572184253.png',
        message: ['8th Generation Intel® Core™ i3 processor'],
    },
    '8gi5': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i5-8th-gen-logo1572888573954411.png',
        message: ['8th Generation Intel® Core™ i5 processor'],
    },
    '8gi7': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/8gi7.png',
        message: ['8th Generation Intel® Core™ i7 processor'],
    },
    xeon: {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-xeon-8th-gen-logo1572913185158604.png',
        message: ['Intel® Xeon® processor'],
    },
    '8gi5-optane': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/8gi5-optane.png',
        message: [
            '8th Generation Intel® Core™ i5+ processor (Core i5 and Intel® Optane™ memory)',
        ],
    },
    '8gi7-optane': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/8gi7-optane.png',
        message: [
            '8th Generation Intel® Core™ i7+ processor (Core i7 and Intel® Optane™ memory)',
        ],
    },
    '8gi9-optane': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/8gi9-optane.png',
        message: [
            '8th Generation Intel® Core™ i9+ processor (Core i9 and Intel® Optane™ memory)',
        ],
    },
    '7gi3': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/7gi3.png',
        message: ['7th Generation Intel® Core™ i3 processor'],
    },
    '7gi5': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/7gi5.png',
        message: ['7th Generation Intel® Core™ i5 processor'],
    },
    '7gi7': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/7gi7.png',
        message: ['7th Generation Intel® Core™ i7 processor'],
    },
    '7gm3': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/marketing/7gm3.png',
        message: ['7th Generation Intel® Core™ m3 processor (m3-7Y30)'],
    },
    '8gi9': {
        url:
            'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/intel-core-i9-8th-gen-logo1573068311890265.jpg',
        message: ['8th Generation Intel® Core™ i9 processor'],
    },

    '11gi3': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/core-i3-rgb1605722054466449.png',
        message: ['11th Generation Intel® Core™ i3 processor']
    },
    '11gi5': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/core-i5-rgb1605722081691287.png',
        message: ['11th Generation Intel® Core™ i5 processor']
    },
    '11gi7': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/core-i7-rgb1605722104151159.png',
        message: ['11th Generation Intel® Core™ i7 processor']
    },
    '11gi9': {
        url: 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/core-i9-rgb1605722131338120.png',
        message: ['11th Generation Intel® Core™ i9 processor']
    }

};

const intelQueryParameterName = 'intel';

const pdpGetIntelBadge = (location) => {
    if (!location || typeof location.search !== 'string') {
        return null;
    }
    const intelQuery = Helpers.getSearch(location.search, true);

    if (
        !intelQuery ||
        typeof intelQuery !== 'object' ||
        typeof intelQuery.jumpid !== 'string' ||
        !/^(em_|cs_|af_|ba_|ps_)/i.test(intelQuery.jumpid)
    ) {
        return null;
    }

    const intelParam = intelQuery[intelQueryParameterName];
    return intelParam ? pdpIntelBadgeMap[intelParam] : null;
};

class PDPIntelBadgeContainer extends React.PureComponent {
    render() {
        const { location } = this.props;
        const intelBadgeImgUrl = pdpGetIntelBadge(location);

        if (intelBadgeImgUrl) {
            return (
                <div className="pdp-intel-badge-container">
                    <IntelContainer
                        src={`${intelBadgeImgUrl.url}?imwidth=50&impolicy=prdimg&imdensity=1`}
                        customMessage={intelBadgeImgUrl.message}
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

export default withError(withRouter(PDPIntelBadgeContainer));
